import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';
import RegistrationForm from './RegistrationForm';
import './Auth.css';

const Auth: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [showRecover, setShowRecover] = useState(false);
  const [recoverEmail, setRecoverEmail] = useState('');
  const [recoverMsg, setRecoverMsg] = useState('');
  const [recoverLoading, setRecoverLoading] = useState(false);

  const { signIn, signUp } = useAuth();

  const handleRecover = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setRecoverLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(
      recoverEmail.trim(),
      { redirectTo: 'https://premios.novagob.org/auth/callback?type=recovery' }
    );
    setRecoverLoading(false);
    if (error) { setError(error.message); return; }
    setRecoverMsg('Si existe una cuenta con ese email, recibirás un enlace para restablecer tu contraseña.');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await signIn(email, password);
      } else {
        await signUp(email, password, { full_name: '' });
      }
    } catch (err: any) {
      setError(err.message || 'Ocurrió un error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className={`auth-card ${!isLogin ? 'auth-card-wide' : ''}`}>
        <div className="auth-logo">
          <h1>Premios NovaGob</h1>
          <p>Excelencia {new Date().getFullYear()}</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {isLogin ? (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label className="form-label">Correo electrónico</label>
              <input
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input
                type="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={loading}
            >
              {loading ? 'Procesando...' : 'Iniciar sesión'}
            </button>

            <div className="auth-divider">
              <span>O</span>
            </div>

            <button
              type="button"
              className="btn btn-secondary w-full"
              onClick={() => setIsLogin(false)}
            >
              Regístrate
            </button>

            <div className="auth-toggle" style={{ marginTop: 12 }}>
              <button
                type="button"
                className="btn-link"
                onClick={() => { setShowRecover(true); setRecoverEmail(email); setError(''); setRecoverMsg(''); }}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>
          </form>
        ) : (
          <RegistrationForm
            onSuccess={() => setIsLogin(true)}
            onCancel={() => setIsLogin(true)}
          />
        )}
      </div>

      {showRecover && (
        <div className="recover-overlay">
          <div className="recover-modal">
            <h3>Recuperar contraseña</h3>
            {recoverMsg ? (
              <>
                <div className="alert alert-success">{recoverMsg}</div>
                <button className="btn btn-primary w-full" onClick={() => { setShowRecover(false); setRecoverMsg(''); }}>
                  Cerrar
                </button>
              </>
            ) : (
              <form onSubmit={handleRecover}>
                <p style={{ color: 'var(--color-text-secondary)', marginBottom: 16, fontSize: 14 }}>
                  Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.
                </p>
                <div className="form-group">
                  <label className="form-label">Correo electrónico</label>
                  <input
                    type="email"
                    className="form-input"
                    value={recoverEmail}
                    onChange={(e) => setRecoverEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
                <button type="submit" className="btn btn-primary w-full" disabled={recoverLoading}>
                  {recoverLoading ? 'Enviando...' : 'Enviar enlace'}
                </button>
                <div className="auth-toggle" style={{ marginTop: 12 }}>
                  <button type="button" className="btn-link" onClick={() => { setShowRecover(false); setError(''); }}>
                    Volver al inicio de sesión
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Auth;
